import React from 'react'

import Container from '../Container'

const Rewards = ({ children }) => (
  <>
    <Container as="main">
      {children}
    </Container>
  </>
)

export default Rewards
